<div class="message-container requested" *ngIf="signatureObject.clientSignature && signatureObject.clientSignature.status === 'REQUESTED'">
	<div class="message" (click)="expanded = !expanded"><em class="fas fa-paper-plane"></em> <span>A signature request has been sent</span> <em *ngIf="!expanded" class="fas fa-angle-down expand"></em><em *ngIf="expanded" class="fas fa-angle-up expand"></em></div>
	<ng-container *ngIf="expanded">
		<div class="data">
			<div class="left">Sent On</div>
			<div class="right">{{ signatureObject.clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data">
			<div class="left">Sent By</div>
			<div class="right">{{ signatureObject.clientSignature.requestedUser }}</div>
		</div>
		<div class="data" *ngFor="let signatory of signatureObject.signatures; let j = index">
			<div class="left">Signer {{ j + 1 }}</div>
			<div class="right" [title]="signatory.signer_email_address">
				{{ signatory.signer_name }}
				<i *ngIf="signatory.status_code === 'awaiting_signature' && !signatory.last_viewed_at" class="fas fa-envelope signer-icon orange" title="Awaiting signature"></i>
				<i *ngIf="signatory.status_code === 'awaiting_signature' && signatory.last_viewed_at" class="fas fa-eye signer-icon orange" title="Viewed"></i>
				<i *ngIf="signatory.status_code === 'signed' || signatory.status_code === 'success'" class="fas fa-check signer-icon green" title="Signed"></i>
			</div>
			<!-- <div class="right" [title]="participant.memberInfos[0].email">
				{{ participant.memberInfos[0].name }}
				<i *ngIf="participant.status === 'WAITING_FOR_OTHERS'" class="fas fa-check signer-icon" title="Signed"></i>
				<i *ngIf="participant.status === 'WAITING_FOR_MY_SIGNATURE'" class="fas fa-envelope signer-icon" title="Awaiting signature"></i>
				<i *ngIf="participant.status === 'NOT_YET_VISIBLE'" class="fas fa-ellipsis-h signer-icon" title="Not yet sent"></i>
			</div> -->
		</div>
		<div class="data">
			<div class="left">Status</div>
			<div class="right">
				<span *ngIf="!loading">{{ signatureObject.clientSignature.status }}</span>
				<i *ngIf="loading" class="fas fa-spinner fa-spin"></i>

			</div>
		</div>
		<div class="data" *ngIf="signatureObject.clientSignature.signatureExpirationDate">
			<div class="left">Expiration Date</div>
			<div class="right">{{ signatureObject.clientSignature.signatureExpirationDate | date:'MMM d, y' }}</div>
		</div>
		<div class="actions" *ngIf="!readonly && signatureObject.clientSignature.requestedUser == contextService.procoreUserInfo.email || contextService.clientDetailProcore.dropboxSignAccountType == 'API' || contextService.signatureCount?.dropboxSignRoleCode == 'a' || ((contextService.clientDetailProcore.anyUserCanCancel || contextService.clientDetailProcore.anyUserCanSendReminder) && contextService.signatureCount?.dropboxSignApiKeyExists)">
			<button *ngIf="signatureObject.clientSignature.requestedUser == contextService.procoreUserInfo.email || contextService.clientDetailProcore.dropboxSignAccountType == 'API' || contextService.signatureCount?.dropboxSignRoleCode == 'a' || (contextService.clientDetailProcore.anyUserCanCancel && contextService.signatureCount?.dropboxSignApiKeyExists)" type="button" class="btn btn-primary btn-md" (click)="cancelRequest()" [disabled]="loading">Cancel Request</button>
			<button *ngIf="signatureObject.clientSignature.requestedUser == contextService.procoreUserInfo.email || contextService.clientDetailProcore.dropboxSignAccountType == 'API' || contextService.signatureCount?.dropboxSignRoleCode == 'a' || (contextService.clientDetailProcore.anyUserCanSendReminder && contextService.signatureCount?.dropboxSignApiKeyExists)" type="button" class="btn btn-primary btn-md" (click)="sendReminder()" [disabled]="loading">Send Reminder</button>
			<button *ngIf="signatureObject.clientSignature.requestedUser == contextService.procoreUserInfo.email || contextService.clientDetailProcore.dropboxSignAccountType == 'API' || contextService.signatureCount?.dropboxSignRoleCode == 'a' || (contextService.clientDetailProcore.anyUserCanDownload && contextService.signatureCount?.dropboxSignApiKeyExists)" type="button" class="btn btn-primary btn-md" (click)="downloadRequest()" [disabled]="loading || loadingDownload"><i *ngIf="loadingDownload" class="fas fa-spinner fa-spin"></i><span *ngIf="!loadingDownload">Download File</span></button>
			<!-- <button type="button" class="btn btn-primary btn-md right" (click)="viewRequest()" [disabled]="loading">View In Adobe Sign</button> -->
		</div>
		<div *ngIf="cancelMessage" class="reminder-container">
			<div>{{ cancelMessage }}</div>
			<button *ngIf="showCancelButton" type="button" class="btn btn-primary btn-md mark-as-cancelled" [disabled]="loading" (click)="markAsCancelled()">Mark as Cancelled</button>
			<button type="button" class="btn btn-primary btn-md" (click)="cancelMessage = ''">Close</button>
		</div>
		<div *ngIf="reminderMessage" class="reminder-container">
			<div>{{ reminderMessage }}</div>
			<button type="button" class="btn btn-primary btn-md" (click)="reminderMessage = ''">Close</button>
		</div>
		<ng-container *ngIf="signatureObject.signatures?.length > 0 && reminders.length > 0">
			<div class="previous-link-container"><a (click)="showReminders = !showReminders">{{ showReminders ? 'Hide Reminder History' : 'View Reminder History'}}</a></div>
			<div class="previous-data-container" *ngIf="showReminders">
				<ng-container *ngFor="let reminder of reminders">
					<div class="group">
						<div class="request-data">
							<div class="left">Sent</div>
							<div class="right">{{ reminder.dateSent | date:'MMM d, y' }}</div>
						</div>
						<div class="request-data">
							<div class="left">Recipient</div>
							<div class="right">{{ reminder.signerEmail }}</div>
						</div>
					</div>
				</ng-container>
			</div>
		</ng-container>
	</ng-container>
</div>

<div class="message-container declined" *ngIf="signatureObject.clientSignature && signatureObject.clientSignature.status === 'CANCELLED'">
	<div class="message" (click)="expanded = !expanded"><em class="fas fa-trash-alt"></em> <span>A request has been cancelled</span> <em *ngIf="!expanded" class="fas fa-angle-down expand"></em><em *ngIf="expanded" class="fas fa-angle-up expand"></em></div>
	<ng-container *ngIf="expanded">
		<div class="data">
			<div class="left">Sent</div>
			<div class="right">{{ signatureObject.clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data" *ngFor="let signatory of signatureObject.signatures; let j = index">
			<div class="left">Signer {{ j + 1 }}</div>
			<div class="right" [title]="signatory.signer_email_address">{{ signatory.signer_name }}</div>
		</div>
		<div class="data">
			<div class="left">Status</div>
			<div class="right">{{ signatureObject.clientSignature.status }}</div>
		</div>
		<!-- <div class="actions">
			<button type="button" class="btn btn-primary btn-md" (click)="viewRequest()" [disabled]="loading">View In Adobe Sign</button>
		</div> -->
	</ng-container>
</div>

<div class="message-container declined" *ngIf="signatureObject.clientSignature && signatureObject.clientSignature.status === 'DECLINED'">
	<div class="message" (click)="expanded = !expanded"><em class="fas fa-thumbs-down"></em> <span>A request has been declined</span> <em *ngIf="!expanded" class="fas fa-angle-down expand"></em><em *ngIf="expanded" class="fas fa-angle-up expand"></em></div>
	<ng-container *ngIf="expanded">
		<div class="data">
			<div class="left">Sent</div>
			<div class="right">{{ signatureObject.clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data" *ngFor="let signatory of signatureObject.signatures; let j = index">
			<div class="left">Signer {{ j + 1 }}</div>
			<div class="right" [title]="signatory.signer_email_address">{{ signatory.signer_name }}</div>
		</div>
		<div class="data">
			<div class="left">Status</div>
			<div class="right">{{ signatureObject.clientSignature.status }}</div>
		</div>
		<!-- <div class="actions">
			<button type="button" class="btn btn-primary btn-md" (click)="viewRequest()" [disabled]="loading">View In Adobe Sign</button>
		</div> -->
	</ng-container>
</div>

<div class="message-container declined" *ngIf="signatureObject.clientSignature && signatureObject.clientSignature.status === 'EXPIRED'">
	<div class="message" (click)="expanded = !expanded"><em class="fas fa-clock"></em> <span>The signature request has expired</span> <em *ngIf="!expanded" class="fas fa-angle-down expand"></em><em *ngIf="expanded" class="fas fa-angle-up expand"></em></div>
	<ng-container *ngIf="expanded">
		<div class="data">
			<div class="left">Sent</div>
			<div class="right">{{ signatureObject.clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data" *ngFor="let signatory of signatureObject.signatures; let j = index">
			<div class="left">Signer {{ j + 1 }}</div>
			<div class="right" [title]="signatory.signer_email_address">
				{{ signatory.signer_name }}
				<i *ngIf="signatory.status_code === 'awaiting_signature' && !signatory.last_viewed_at" class="fas fa-envelope signer-icon orange" title="Awaiting signature"></i>
				<i *ngIf="signatory.status_code === 'awaiting_signature' && signatory.last_viewed_at" class="fas fa-eye signer-icon orange" title="Viewed"></i>
				<i *ngIf="signatory.status_code === 'signed' || signatory.status_code === 'success'" class="fas fa-check signer-icon green" title="Signed"></i>
			</div>
		</div>
		<div class="data">
			<div class="left">Status</div>
			<div class="right">
				<span *ngIf="!loading">{{ signatureObject.clientSignature.status }}</span>
				<i *ngIf="loading" class="fas fa-spinner fa-spin"></i>

			</div>
		</div>
		<!-- <div class="actions"> -->
		<!-- <button type="button" class="btn btn-primary btn-md left" (click)="cancelRequest()" [disabled]="loading">Cancel Request</button> -->
		<!-- <button type="button" class="btn btn-primary btn-md right" (click)="sendReminder()" [disabled]="loading">Send Reminder</button> -->
		<!-- <button type="button" class="btn btn-primary btn-md right" (click)="viewRequest()" [disabled]="loading">View In Adobe Sign</button> -->
		<!-- </div> -->


	</ng-container>
</div>

<div class="message-container completed" *ngIf="signatureObject.clientSignature && signatureObject.clientSignature.status === 'COMPLETED'">
	<div class="message" (click)="expanded = !expanded"><em class="fas fa-check"></em> <span>A request has been completed</span> <em *ngIf="!expanded" class="fas fa-angle-down expand"></em><em *ngIf="expanded" class="fas fa-angle-up expand"></em></div>
	<ng-container *ngIf="expanded">
		<div class="data">
			<div class="left">Sent</div>
			<div class="right">{{ signatureObject.clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data">
			<div class="left">Completed</div>
			<div class="right">{{ signatureObject.clientSignature.signatureCompleteDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data" *ngFor="let signatory of signatureObject.signatures; let j = index">
			<div class="left">Signer {{ j + 1 }}</div>
			<div class="right" [title]="signatory.signer_email_address">{{ signatory.signer_name }}</div>
		</div>
		<div class="actions" *ngIf="!readonly && signatureObject.clientSignature.requestedUser == contextService.procoreUserInfo.email || contextService.clientDetailProcore.dropboxSignAccountType == 'API' || contextService.signatureCount?.dropboxSignRoleCode == 'a' || (contextService.clientDetailProcore.anyUserCanDownload && contextService.signatureCount?.dropboxSignApiKeyExists)">
			<!-- <button type="button" class="btn btn-primary btn-md left" (click)="viewRequest()" [disabled]="loading">View In Adobe Sign</button> -->
			<button *ngIf="signatureObject.clientSignature.requestedUser == contextService.procoreUserInfo.email || contextService.clientDetailProcore.dropboxSignAccountType == 'API' || contextService.signatureCount?.dropboxSignRoleCode == 'a' || (contextService.clientDetailProcore.anyUserCanDownload && contextService.signatureCount?.dropboxSignApiKeyExists)" type="button" class="btn btn-primary btn-md" (click)="downloadRequest()" [disabled]="loading || loadingDownload"><i *ngIf="loadingDownload" class="fas fa-spinner fa-spin"></i><span *ngIf="!loadingDownload">Download File</span></button>
		</div>
	</ng-container>
</div>